import { useState, useEffect, useContext } from "react";
import { ImageContext } from "../Component/Context/ImageContext";
// import { createPattern } from "../Component/Desktop/Pattern";
import { createPattern } from "../Component/Desktop/createPattern";
import { DEFAULT_POINTS, INITIAL_DOOR_DIMENSIONS } from "../Constants/constants";

export const useDoorLogic = () => {
  const { deskimg, deskpoint, setImgurl } = useContext(ImageContext);
  
  // State management
  const [selectedColor, setSelectedColor] = useState("#3f3f3b");
  const [selectedPattern, setSelectedPattern] = useState("sectional");
  const [selectSeries, setSelectseries] = useState("Essentials");
  const [selectedDesign, setSelectedDesign] = useState("Madison");
  const [selectedPanelStyle, setPanelStyle] = useState("");
  const [colorname, setColorName] = useState("Zinc graphite");
  const [selctwindow, setSelectWindow] = useState("");
  const [SelectedMaterial, setSelectedMaterial] = useState("Composite");
  const [backImage, setBackImage] = useState(deskimg || null);
  const [image, setImage] = useState(null);
  const [doorWidth, setDoorWidth] = useState("double door");
  
  const [points, setPoints] = useState(
    deskpoint || DEFAULT_POINTS.DEFAULT
  );

  // console.log("craete pattren", createPattern)
  // Apply door design function
  const applyDoorDesign = async (
    color = selectedColor,
    pattern = selectedPattern,
    design = selectedDesign,
    series = selectSeries,
    panelStyle = selectedPanelStyle,
    windowstyle = selctwindow,
    material = SelectedMaterial
  ) => {
    const patternFill = await createPattern(
      color,
      pattern,
      design,
      series,
      panelStyle,
      windowstyle,
      material
    );
    if (patternFill) {
      setImage(patternFill);
    }
  };

  // Reset to default values
  const resetToDefault = () => {
    setColorName("Zinc graphite");
    setSelectedPattern("sectional");
    setSelectedDesign("");
    setSelectedColor("#3f3f3b");
    setPanelStyle("");
    setSelectseries("");
    setSelectWindow("");
  };

  // Handle series change logic
  const handleSeriesChange = (newSeries) => {
    let newDesign = selectedDesign;
    let newPanelStyle = selectedPanelStyle;
    let newWindowStyle = selctwindow;
    let newmaterial = SelectedMaterial;

    if (newSeries === "Essentials") {
      newDesign = "Oxford";
      newPanelStyle = "";
    } else if (newSeries === "Native") {
      newDesign = "Madison";
      newPanelStyle = "";
      newWindowStyle = "";
    } else if (newSeries === "Selections Series") {
      newPanelStyle = "Alumicomp";
      newDesign = "Sovereign";
      newWindowStyle = "";
      newmaterial = "Composite";
    }

    setSelectseries(newSeries);
    setSelectedDesign(newDesign);
    setPanelStyle(newPanelStyle);
    setSelectWindow(newWindowStyle);
    setSelectedMaterial(newmaterial);

    applyDoorDesign(
      selectedColor,
      newSeries,
      newDesign,
      newPanelStyle,
      newWindowStyle,
      newmaterial
    );
  };

  // Handle pattern change logic
  const handlePatternChange = (patternName) => {
    setSelectedPattern(patternName);
    applyDoorDesign(selectedColor, patternName);

    if (patternName === "sectional") {
      setSelectseries("Essentials");
      setSelectedDesign("Madison");
    }
    if (patternName === "roller") {
      setSelectseries("");
      setSelectedDesign("");
      setPanelStyle("");
      setSelectWindow("");
    }
  };

  // Handle panel style change logic
  const handlePanelStyleChange = (panelName) => {
    setPanelStyle(panelName);
    applyDoorDesign(selectedColor, panelName);
    
    if (panelName === "Alumicomp") {
      setSelectedDesign("Sovereign");
      setSelectedMaterial("Composite");
    }
  };

  // Apply door design effect
  useEffect(() => {
    if (backImage) {
      applyDoorDesign();
    }
  }, [
    selectedColor,
    selectedPattern,
    selectedDesign,
    selectSeries,
    selectedPanelStyle,
    selctwindow,
    SelectedMaterial,
    backImage,
  ]);

  return {
    // State values
    selectedColor,
    selectedPattern,
    selectSeries,
    selectedDesign,
    selectedPanelStyle,
    colorname,
    selctwindow,
    SelectedMaterial,
    backImage,
    image,
    doorWidth,
    points,
    
    // State setters
    setSelectedColor,
    setSelectedPattern,
    setSelectseries,
    setSelectedDesign,
    setPanelStyle,
    setColorName,
    setSelectWindow,
    setSelectedMaterial,
    setBackImage,
    setImage,
    setDoorWidth,
    setPoints,
    
    // Logic functions
    applyDoorDesign,
    resetToDefault,
    handleSeriesChange,
    handlePatternChange,
    handlePanelStyleChange,
  };
};